import { render, staticRenderFns } from "./ActionListApproveForm.vue?vue&type=template&id=0987f97a&"
import script from "./ActionListApproveForm.vue?vue&type=script&lang=ts&"
export * from "./ActionListApproveForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports